import { render, staticRenderFns } from "./nxEnum.vue?vue&type=template&id=60f00a75&scoped=true&"
import script from "./nxEnum.vue?vue&type=script&lang=js&"
export * from "./nxEnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f00a75",
  null
  
)

export default component.exports